export const SMS_MFA = 'SMS_MFA';
export const SOFTWARE_TOKEN_MFA = 'SOFTWARE_TOKEN_MFA';